<template>
  <div>
    <!-- 新增 -->
    <el-dialog title="添加协议" @open="clearAddForm" :close-on-click-modal="false" :visible.sync="addDialogVisible" width="800px" center>
      <el-form ref="addForm" :model="addForm">
        <el-form-item :rules="[{required:true,message:'协议名不能为空'}]" label="协议名称" prop="name">
          <el-input ref="focusinput" v-model="addForm.name" placeholder="请输入协议名称" maxlength="16"></el-input>
        </el-form-item>
        <b>点位属性</b>
        <el-button size="small" type="primary" plain
            @click="addItem('add')"
          >添加</el-button >
          <!-- <el-button size="small" type="danger" plain
            @click="()=>{
              this.addForm.pointAttr.splice(this.addForm.pointAttr.length-1,1)
              }"
          >删除</el-button >--><br><br> 
          <div >
             <el-table :data="addForm.pointAttr" Height ='446'   style="width: 100%;margin-bottom:10px; overflow-y: auto;max-height:446px"  >
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                        <el-form-item>
                            <span>{{scope.$index+1}}</span>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="属性名" min-width="100">
                    <template slot-scope="scope"> 
                        <el-form-item :prop="`pointAttr[${scope.$index}].name`" :rules="{required:true,message:'属性名不能为空',trigger: 'blur'}">
                            <el-input :ref="`focusprocedure${scope.$index}`" size="small" maxlength="16" v-model="scope.row.name"></el-input>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="属性值" min-width="130" v-if="addForm.type!=0">
                    <template slot-scope="scope">
                        <el-form-item :prop="`pointAttr[${scope.$index}].value`" :rules="[{required:true,message:'属性值不能为空'}]">
                           <el-input size="small" maxlength="16" v-model="scope.row.value"></el-input>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="操作"  width="60">
                    <template slot-scope="scope">
                        <el-form-item>
                        <div class="delete"   type="primary"  @click="removePoint(scope.$index)"></div>
                        </el-form-item>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <el-row v-for="(item,index) in addForm.pointAttr" :key="index">
              <el-col :span="10">
                <el-form-item :rules="{required:true,message:'属性名不能为空',trigger: 'blur'}" label-width="100px" label="key" :prop="'pointAttr.'+index+'.name'">
                  <el-input v-model="item.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :rules="[{required:true,message:'属性值不能为空'}]" label-width="100px" label="value" :prop="'pointAttr.'+index+'.value'">
                  <el-input v-model="item.value"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <div class="delete"   type="primary"  @click="removePoint(index)"></div>
                </el-form-item>
              </el-col>
            </el-row> -->
          </div>
      </el-form>
      <span slot="footer" class="el-dialog__footer" style="text-align: center;" center>
        <el-button type="primary" @click="addProtocol">确 定</el-button> 
      </span>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog title="编辑协议" @open="clearEditForm" :visible.sync="editDialogVisible" width="800px" :close-on-click-modal="false" center>
      <el-form ref="editForm" :model="editForm">
        <el-form-item :rules="[{required:true,message:'协议名不能为空'}]" label="协议名称" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入协议名称" maxlength="16"></el-input>
        </el-form-item>
        <b>点位属性 </b>
        <el-button size="small" type="primary" plain
            @click="addItem('edit')"
          >添加</el-button >
          <!-- <el-button size="small" type="danger" plain
            @click="()=>{
              this.editForm.pointAttr.splice(this.editForm.pointAttr.length-1,1)
              }"
          >删除</el-button > -->
          <br><br>
          <div >
            <el-table :data="editForm.pointAttr" Height ='446'   style="width: 100%;margin-bottom:10px; overflow-y: auto;max-height:446px"  >
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                        <el-form-item>
                            <span>{{scope.$index+1}}</span>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="属性名" min-width="100">
                    <template slot-scope="scope"> 
                        <el-form-item :prop="`pointAttr[${scope.$index}].name`" :rules="{required:true,message:'属性名不能为空',trigger: 'blur'}">
                            <el-input :ref="`focusprocedure${scope.$index}`" size="small" maxlength="16" v-model="scope.row.name"></el-input>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="属性值" min-width="130" v-if="addForm.type!=0">
                    <template slot-scope="scope">
                        <el-form-item :prop="`pointAttr[${scope.$index}].value`" :rules="[{required:true,message:'属性值不能为空'}]">
                           <el-input size="small" maxlength="16" v-model="scope.row.value"></el-input>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="操作"  width="60">
                    <template slot-scope="scope">
                        <el-form-item>
                        <div class="delete"   type="primary"  @click="removePoint1(scope.$index)"></div>
                        </el-form-item>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <el-row v-for="(item,index) in editForm.pointAttr" :key="index">
            <el-col :span="10">
              <el-form-item :rules="{required:true,message:'属性名不能为空',trigger: 'blur'}" label-width="100px" label="key" :prop="'pointAttr.'+index+'.name'">
                <el-input v-model="item.name"></el-input>
              </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :rules="[{required:true,message:'属性值不能为空'}]" label-width="100px" label="value" :prop="'pointAttr.'+index+'.value'">
                  <el-input v-model="item.value"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <div class="delete"   type="primary"  @click="removePoint1(index)"></div>
                </el-form-item>
              </el-col>
            </el-row> -->
          </div>
      </el-form>
      <span slot="footer" class="el-dialog__footer" style="text-align: center;" center>
        <el-button type="primary" @click="editProtocol">确 定</el-button> 
      </span>
    </el-dialog>

    <!-- 协议详情 -->
    <el-dialog title="协议详情" :visible.sync="detailDialogVisible" width="600px" center :close-on-click-modal="false">
      <el-row>
        <b>协议名：</b><span>{{protocolDetail.name}}</span>
      </el-row>
      <el-row>
        <el-col :span="6"><b>点位模板</b></el-col>
        <el-col :span="18">
          <el-row v-for="item in protocolDetail.pointAttr" :key="item.id">
            <el-col :span="4">属性名：</el-col>
            <el-col :span="8">{{item.name}}</el-col>
            <el-col :span="4">属性值：</el-col>
            <el-col :span="8">{{item.value}}</el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-dialog>
    <div class="table_common_operbar">
        <el-row>
            <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow" v-if="permission.btn_protocol_add">新增</el-button>
        </el-row>
    </div>
    <el-table :data="tableData" stripe style="width: 100%" class="deviceTable">
        <el-table-column prop="name" label="协议名称" min-width="160"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="gmtCreate" :formatter='parseDate' label="创建日期" min-width="70"></el-table-column>
        <el-table-column label="操作" fixed="right" >
            <template slot-scope="scope">
                <el-button @click="showDetailDialog(scope.row)" type="text" size="small" v-if="permission.btn_protocol_get">查看</el-button>
                <el-button @click="showEditDialog(scope.row)" type="text" size="small" v-if="permission.btn_protocol_update">编辑</el-button>
                <el-button @click="delProtocol(scope.row)" type="text" size="small" v-if="permission.btn_protocol_delete">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div class="page" v-if="tableData.length > 0">
            <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
            <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                </el-pagination>
            </div>
    </div>
  </div>
</template>
<script>
export default {
  name:"protocolMgt",
  data:()=>{
    return{
      fristLoad:false,
      addDialogVisible:false,
      editDialogVisible:false,
      detailDialogVisible:false,
      tableCurrentPage:1,
      tableTotalPage:100,
      tableData:[],
      protocolDetail:{},
      addForm:{
        name,
        pointAttr:[{name:'',value:''}]
      },
      editForm:{
        id:'',
        name,
        pointAttr:[{name:'',value:''}]
      },
      permission:JSON.parse(localStorage.getItem("permission"))
    }
  },
  mounted:function(){
    this.search();
  },
  methods:{
    addItem(type){
      if(type=='add'){
        let index = this.addForm.pointAttr.length
        this.addForm.pointAttr.push({key:'',value:''})
        setTimeout(()=>{
              this.$refs[`focusprocedure${index}`].focus()
        },0)
      }else{
          let index = this.editForm.pointAttr.length
          this.editForm.pointAttr.push({key:'',value:''})
          setTimeout(()=>{
                this.$refs[`focusprocedure${index}`].focus()
          },0)
      }
    },
    
    addWindowShow(){
      this.addDialogVisible=true
      setTimeout(()=>{
          this.$refs.focusinput.focus()
      },0)
    },
    removePoint(index){
      if(this.addForm.pointAttr.length === 1 ){
        this.$message.warning("至少保留一个属性")
      }else{
        this.addForm.pointAttr.splice(index,1);
      }
    },
    removePoint1(index){
      console.log(this.editForm.pointAttr.length)
      if(this.editForm.pointAttr.length === 1 ){
        this.$message.warning("至少保留一个属性")
      }else{
        this.editForm.pointAttr.splice(index,1);
      }
    },
    search:function(){
      this.$RequestUtil.get({
        url: '/api/sysProtocol/listProtocol',
        type:'sync',
        params: {
              pageNum:this.tableCurrentPage,
              pageSize:10,
          },
          success: (res) => {
              if(res.msg == this.$Global.RESPONSE.SUCCESS){
                  this.tableData = res.data;
                  this.tableTotalPage = res.totalPages;
                  if(res.totalPages == 0&&this.fristLoad){
                      this.$message.warning('查询不到符合条件的数据');
                  }
                  this.fristLoad = true
              }else{
                  this.$message.error(res.msg||res.message);
                  
              }
          }
      });
    },
    pageChange:function(targetPage){
        this.tableCurrentPage = targetPage;
        this.btnPressType = 3;
        this.search();
    },
    parseDate:function(rowData){
        if(rowData.gmtCreate != null){
            let dateString = commonUtils.timestampToDate(rowData.gmtCreate,true);
            return dateString;
        }
    },
    addProtocol(){
      this.$refs["addForm"].validate(vali=>{
        if(vali){
          this.$RequestUtil.post({
              url: '/api/sysProtocol/addProtocol',
              type:'sync',
              params: {
                name:this.addForm.name,
                type:0,
                pointTemplateList:this.addForm.pointAttr
              },
              success: (res) => {
                  if(res.code == 0){
                      this.$message({
                          type:'success',
                          message:'添加成功'
                      })
                      this.search();
                      this.addDialogVisible = false;
                  }else{
                      this.$message({
                          type:'error',
                          message:res.msg||res.message
                      })
                  }
              }
          })
        }
      })
    },
    clearAddForm(){
      this.addForm = {
        name:'',
        pointAttr:[{name:'',value:''}]
      }
      this.$nextTick(()=>{
        this.$refs["addForm"]&&this.$refs["addForm"].clearValidate();
      })
    },
    async showEditDialog(row){
      await this.getProtocolDetail(row);
      this.editDialogVisible=true;
      this.$nextTick(()=>{
        this.editForm.id = row.id;
        this.editForm.name = this.protocolDetail.name;
        this.editForm.pointAttr = this.protocolDetail.pointAttr;
      })
    },
    editProtocol(){
      this.$refs["editForm"].validate((vali,o)=>{
        if(vali){
          this.$RequestUtil.post({
              url: '/api/sysProtocol/updateProtocol',
              type:'sync',
              params: {
                id: this.editForm.id,
                name:this.editForm.name,
                type:0,
                pointTemplateList:this.editForm.pointAttr
              },
              success: (res) => {
                  if(res.code == 0){
                      this.$message({
                          type:'success',
                          message:'编辑成功'
                      })
                      this.search();
                      this.editDialogVisible = false;
                  }else{
                      this.$message({
                          type:'error',
                          message:res.msg||res.message
                      })
                  }
              }
          })
        }
      })
    },
    clearEditForm(){
      this.editForm.name = '';
      this.editForm = {
        name:'',
        pointAttr:[{name:'',value:''}]
      }
      this.$nextTick(()=>{
        this.$refs["editForm"]&&this.$refs["editForm"].clearValidate();
      })
    },
    delProtocol(row){
      this.$confirm("是否确认删除", '提示', {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        this.$RequestUtil.get({
            url: '/api/sysProtocol/deleteProtocol',
            type:'sync',
            params: {
                id:row.id
            },
            success: (res) => {
                if(res.code != -1){
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.search();
                    this.$store.commit("add_reloadPages",['/WorkShop']);
                }else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  });
                }
            }
        });
      });
    },
    async showDetailDialog(row){
      await this.getProtocolDetail(row);
      this.detailDialogVisible = true;
    },
    getProtocolDetail(row){
      return new Promise((resolve,reject)=>{
        this.protocolDetail.name = row.name;
        this.$RequestUtil.get({
          url: '/api/sysProtocol/getPointTemplates',
            type:'sync',
            params: {
                id:row.id
            },
            success: (res) => {
                if(res.code != -1){
                  this.protocolDetail.pointAttr = res.data;
                  resolve();
                }else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  });
                  reject(res.msg);
                }
            }
        });
      })
      
    }
  }
}
</script>
<style scoped>
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin: 16px 0;
}
.delete{
    width: 18px;
    height: 19px;
    background-image:url('../../../static/img/del.png');
    cursor: pointer;
    background-repeat: no-repeat;
}
.delete:hover{

    background-image: url('../../../static/img/del-hover.png');
    background-repeat: no-repeat;
}
.page{
    display: flex;
    justify-content: flex-end;
}

.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.el-row{
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/protocol/ProtocolMgt.vue